'use strict'

NEARBY_DEALS_TO_SHOW_WHEN_PLACE_HAS_NO_DEALS = 3

GdtWidget = require '../../gdt/frontend/gdt_widget'
NearbyDeals = require './nearby_deals'

module.exports = class PlacePreviewDrawer

  onCloseCallbacks: null

  templates:
    main: require '../main.html.mustache'
    oneDeal: require '../one_deal.html.mustache'
    dealCard: require '../../deals/deal_card.html.mustache'
    couponCard: require '../../coupons/coupon_card.html.mustache'
    gdtWidget: require '../../gdt/main.html.mustache'
    address:
      US: require '../../merchant_information/address_templates/address_US.html.mustache'
      DE: require '../../merchant_information/address_templates/address_DE.html.mustache'
      ES: require '../../merchant_information/address_templates/address_ES.html.mustache'
      FR: require '../../merchant_information/address_templates/address_FR.html.mustache'
      GB: require '../../merchant_information/address_templates/address_GB.html.mustache'
      IT: require '../../merchant_information/address_templates/address_IT.html.mustache'

  constructor: ({ @place, @$el }) ->
    @id = Math.floor(Math.random() * (9999 - 1000)) + 1000
    @onCloseCallbacks = []
    @render()

  render: ->
    template = if @shouldUseOneDealTemplate() then @templates.oneDeal else @templates.main
    html = template.render @placeTemplateData()

    @$el.html html
    GIG.Utils.truncateElements @$el
    @$el.removeClass 'hidden'

    @$el.find('.icon-x').click => @hide()

    @$el.find('.mpp-coupon-card').click (evt) =>
      couponId = $(evt.currentTarget).data 'id'
      window.open "/biz/#{@place.slug}?coupon_id=#{couponId}"

    $gdtWrapper = @$el.find '.place-preview-gdt'

    if $gdtWrapper.length > 0
      new GdtWidget {
        el: @$el.find '.gdt-widget'
        desktopWrapper: $gdtWrapper
        place:
          placeId: @place.uuid
          placeSlug: @place.slug
      }

    $nearbyDeals = @$el.find '.place-preview-nearby-deals'
    if $nearbyDeals.length > 0
      new NearbyDeals {
        $el: $nearbyDeals
        place: @place
        limit: NEARBY_DEALS_TO_SHOW_WHEN_PLACE_HAS_NO_DEALS
      }

    @$el

  hasOffers: ->
    @hasDeals() or @hasCoupons() or @hasGdt()

  hasDeals: ->
    @place?.offers?.deal?.items?.length > 0

  hasCoupons: ->
    @place?.offers?.coupon?.items?.length > 0

  hasGdt: ->
    @place?.offers?.gdt?.data?.gdtFeatures? and \
      (@place.offers.gdt.data.gdtFeatures.offersDelivery or \
      @place.offers.gdt.data.gdtFeatures.offersTakeout)

  shouldUseOneDealTemplate: ->
    @place.offers? and \
      @place.offers.deal?.items?.length is 1 and not @hasCoupons()

  addressHtml: ->
    data = @place.location
    template = @templates.address[I18n.country] ? @templates.address['US']
    template.render data

  couponsHtml: ->
    coupons = @place.offers?.coupon?.items
    return null unless coupons?.length > 0

    couponsHtml = ''
    for coupon in coupons
      coupon.translate = coupon.t = -> (str) -> I18n.t str
      couponsHtml += @templates.couponCard.render coupon

    couponsHtml

  dealsHtml: ->
    deals = @place.offers?.deal?.items
    return null unless deals?.length > 0

    dealsHtml = ''
    for deal in deals
      deal.forceMobileStyles = true
      deal.translate = deal.t = -> (str) -> I18n.t str
      dealsHtml += @templates.dealCard.render deal

    dealsHtml

  gdtHtml: ->
    # We only want to show GDT if there are no other offers.
    return null unless @hasGdt() and not (@hasDeals() or @hasCoupons())

    data = { gdt: @place.offers?.gdt?.templateData }
    data.translate = data.t = -> (str) -> I18n.t str
    @templates.gdtWidget.render data

  gdtShortText: ->
    return null unless @hasGdt()

    discount = @place.offers.gdt.data.discountBps

    if discount > 0
      I18n.t 'js.modules.offers_map_preview_drawer.online_ordering_available.with_percentage_off', { percentage: discount / 100 }
    else
      I18n.t 'js.modules.offers_map_preview_drawer.online_ordering_available.default'

  oneDealData: ->
    deal = @place.offers?.deal?.items?[0]
    return null unless deal?

    _.extend deal,
      headerImage: deal.sidebarImageUrl?.replace /\/[tc][0-9]+x[0-9]+\./, '/t600x320.'

  getViewPageButtonTranslation: ->
    return I18n.t('js.modules.offers_map_preview_drawer.view_deal') if @shouldUseOneDealTemplate()

    offerCount = 0
    offerCount += @place.offers.deal.total if @place.offers?.deal?.total > 0
    offerCount += @place.offers.coupon.total if @place.offers?.coupon?.total > 0

    if offerCount > 10
      I18n.t 'js.modules.offers_map_preview_drawer.view_all_x_offers', { count: offerCount }
    else
      I18n.t 'js.modules.offers_map_preview_drawer.view_page'

  placeTemplateData: ->
    data = {}
    data.translate = data.t = -> (str) -> I18n.t str

    _.extend data, @place,
      noOffers: not @hasOffers()
      deal: @oneDealData()
      addressHtml: @addressHtml()
      dealsHtml: @dealsHtml()
      couponsHtml: @couponsHtml()
      gdtHtml: @gdtHtml()
      gdtShortText: @gdtShortText()
      translations:
        notRunningDeal: I18n.t 'js.modules.offers_map_preview_drawer.not_running_any_deal',
          merchantName: @place.name
        viewPageButton: @getViewPageButtonTranslation()

  isVisible: ->
    @$el.hasClass('hidden') is false

  hide: (data) ->
    @$el.addClass 'hidden'
    @triggerClose data

  triggerClose: (data) ->
    for cb in @onCloseCallbacks
      cb data
    @onCloseCallbacks = []

  onceOnClose: (cb) ->
    @onCloseCallbacks.push cb
